import * as React from "react";
import PropTypes from "prop-types";
const SvgAchievementsTrophy06Small = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M12.625 8.75a.625.625 0 110 1.25h-1.25a.625.625 0 110-1.25z" />
        <path d="M5 0a1 1 0 00-1 1v1H2a2 2 0 00-2 2v4a5 5 0 005 5h1.186a10.986 10.986 0 004.6 3.579l.214.089v1.851l-4.625 3.7A1 1 0 007 24h10a1 1 0 00.625-1.78L13 18.52v-1.852l.214-.089a10.986 10.986 0 004.6-3.579H19a5 5 0 005-5V4a2 2 0 00-2-2h-2V1a1 1 0 00-1-1zm15 4h2v4a3 3 0 01-3 3c.647-1.41 1-2.967 1-4.582zM2 4h2v2.418C4 8.033 4.353 9.59 5 11a3 3 0 01-3-3zm7.025 5.027c.07-.65.283-1.276.625-1.837L11.6 4h2.05l-1.833 3h.808A2.375 2.375 0 0115 9.375 2.625 2.625 0 0112.375 12h-.75a2.625 2.625 0 01-2.622-2.5H9a4.452 4.452 0 010-.125c0-.118.009-.235.025-.348z" />
      </g>
    </svg>
  )
);
SvgAchievementsTrophy06Small.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgAchievementsTrophy06Small;
